<template>
  <div>
    <div class="flex justify-between mb-4">
      <h3 class="text-lg font-medium">
        Notes
      </h3>
    </div>
    <div class="w-full">
      <label
        for="notes"
        class="block text-gray-700 mb-2 font-medium"
      >Contact Notes</label>
      <Textarea 
        id="notes" 
        :model-value="contact.notes || ''" 
        :disabled="!isEditing"
        class="w-full" 
        rows="10" 
        placeholder="Enter contact notes here..."
        @update:model-value="updateNotes" 
      />
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    contact: {
        type: Object,
        required: true
    },
    isEditing: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:contact']);

const updateNotes = (value) => {
    const updatedContact = { ...props.contact, notes: value };
    emit('update:contact', updatedContact);
};
</script> 